export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export const siteInfo = {
  name: '瓜田快报',
  englishName: 'Guatian Kuaibao',
  slogan: '名场面不费力，一瓜看通透',
  description:
    '瓜田快报专注私拍吃瓜名场面与抓拍盘点，把神操作、尴尬瞬间、高光瞬间集中整理到同一条时间线上，最新热门优先展示。想吃透一段画面，点标题就能快速定位关键瞬间。',
  email: 'hi@guatiankuaibao.com',
  domain: 'https://gotzxpl.cn',
};

export const siteStats = [
  { value: '1,200+', label: '已整理名场面' },
  { value: '6', label: '主题分类' },
  { value: '3,800+', label: '标注关键画面' },
  { value: '每日', label: '热门优先更新' },
];

export const navLinks = [
  { to: '/', label: '首页' },
  { to: '/moments', label: '名场面图鉴' },
  { to: '/about', label: '关于瓜田' },
];

export const contentPrinciples = [
  {
    icon: 'ri-time-line',
    title: '只标关键，不注水',
    desc: '每条内容都拆出可跳转的关键画面节点，先给时间点，再给说明，不让你为了三十秒画面翻十分钟。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '尴尬与高光分开写',
    desc: '尴尬瞬间看的是真实反应，高光瞬间看的是掌控力，两种情绪不混在同一段描述里。',
  },
  {
    icon: 'ri-links-line',
    title: '站内互链，越看越顺',
    desc: '详情页底部给出同分类推荐，看完一段可以直接顺到下一段，不用回到列表重新找。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '只整理观看顺序',
    desc: '我们做的是顺序与说明的整理，画面版权归原发布方所有，涉及隐私的内容一律不收录。',
  },
];

export const testimonials: Testimonial[] = [
  {
    name: '小满',
    role: '短视频重度用户',
    content: '以前看这类盘点要在评论区翻半天时间点，这里直接写在目录里，点进去就能看到那几秒，真的省事。',
  },
  {
    name: '阿昼',
    role: '综艺爱好者',
    content: '分类做得很清楚，尴尬瞬间和高光瞬间是分开的。想看好笑的就看好笑的，想看厉害的就看厉害的。',
  },
  {
    name: '林可',
    role: '内容搬运工',
    content: '写整理稿的时候会来这里找参考，关键画面拆得好，描述也基本没有主观发挥，引用起来很放心。',
  },
];